import React, { Component } from "react";
import $ from "jquery";
import Calendar from "react-calendar";
import "react-calendar/dist/Calendar.css";
import { ToastContainer, toast } from "react-toastify";
import GetDomains from "../GetDomains";
import Select from "react-select";
import { Multiselect } from "multiselect-react-dropdown";

var maxDate = new Date();
maxDate.setDate(maxDate.getDate() - 1);

class GenerateReport extends Component {
  constructor() {
    super();
    this.multiselectRef = React.createRef();
    console.log(new Date().toDateString());
    this.state = {
      date: new Date(),
      selectRange: {},
      startTime: new Date(new Date().toDateString()).getTime(),
      intervalStartTime: new Date(new Date().toDateString()).getTime(),
      intervalEndTime: new Date(new Date().toDateString()).getTime(),
      selectedDomainName: null,
      selectedDomainId: null,
      selectedReportType: "",
      intervalReportType: "",
      selectedDailyReportDomains: [],
    };
    this.domains = [];
  }

  handleDailyReportDomainChange = (selectedDailyReportDomains) => {
    this.setState({ selectedDailyReportDomains: this.cleanDomainLabels(selectedDailyReportDomains) });
  };

  cleanDomainLabels = (domainsList = []) => {
    // return domainsList.map(domain => ({ ...domain, label: domain.label.trim().replace("↪", "") }));
    domainsList.forEach(domain => {
      domain.label = domain.label.trim().replace("↪", "");
    });
    return domainsList;

  }


  handleRemoveDailyReportDomain = (selectedDailyReportDomains) => {
    this.setState({ selectedDailyReportDomains: this.cleanDomainLabels(selectedDailyReportDomains) });
  };

  resetValues = () => {
    this.multiselectRef.current.resetSelectedValues();
  };

  componentDidMount() {
    this.fetchDomainsApi();
    var thisController = this;
    document.addEventListener("projectChanged", function (event) {
      thisController.projectId = event.projectId;
      thisController.domains = [];
      thisController.state.selectedDailyReportDomains = [];
      thisController.fetchDomainsApi();
    });
  }

  fetchDomainsApi = () => {
    var domainList = GetDomains();
    var isDomainIdInCurrentProject = false;
    for (var i = 0; i < domainList.length; i++) {
      if (
        localStorage.getItem("convDataDomainId") !== undefined &&
        domainList[i]["domainId"] === localStorage.getItem("convDataDomainId")
      ) {
        isDomainIdInCurrentProject = true;
      }
      this.domains.push({
        value: domainList[i]["domainId"],
        label: domainList[i]["domain"],
      });
    }

    if (this.props.location.state !== undefined) {
      if (isDomainIdInCurrentProject) {
        this.state.selectedDomainName =
          localStorage.getItem("convDataDomainName");
        this.state.selectedDomainId = localStorage.getItem("convDataDomainId");
      } else {
        this.state.selectedDomainName = this.domains[0].label;
        this.state.selectedDomainId = domainList[0]["domainId"];
      }
    } else {
      this.state.selectedDomainName = this.domains[0].label;
      this.state.selectedDomainId = domainList[0]["domainId"];
    }
  };

  handleDomainChange = (e) => {
    console.log("Changed to domain: " + e.label);
    this.state.selectedDomainName = e.label;
    this.state.selectedDomainId = e.value;
    localStorage.setItem("convDataDomainName", e.label);
    localStorage.setItem("convDataDomainId", e.value);
    this.setState(this.state);
  };

  onChange = (date) => {
    var stateObj = this;
    var startTime = date.getTime();
    stateObj.state.date = date;
    stateObj.setState({
      startTime: startTime,
    });
  };

  onDateChange = (selectRange) => {
    var stateObj = this;
    var rangeStartDate = selectRange[0];
    var rangeEndDate = selectRange[selectRange.length - 1];

    var startDate = new Date(rangeStartDate.toDateString()).getTime();
    var endDate = rangeEndDate.getTime();
    stateObj.setState({
      intervalStartTime: startDate,
      intervalEndTime: endDate,
    });
  };

  downloadReport = () => {
    const reportTypeElements = document.getElementsByName("reportType");
    let selectedReportTypeValue = null;
    let parentDomainIdList = [];
    let domainSelected = true;

    for (let i = 0; i < reportTypeElements.length; i++) {
      if (reportTypeElements[i].checked) {
        selectedReportTypeValue = reportTypeElements[i].value;
        if (selectedReportTypeValue === "DOMAIN_WISE_REPORT") {
          if (this.state.selectedDomainId != null) {
            parentDomainIdList = [this.state.selectedDomainId];
          } else {
            domainSelected = false;
          }
        }
        if (selectedReportTypeValue === "DAILY_SUMMARY") {
          if (this.state.selectedDailyReportDomains.length > 0) {
            parentDomainIdList = this.state.selectedDailyReportDomains.map(domain => domain.value);
          } else {
            domainSelected = false;
          }
        }
        break;
      }
    }

    if (domainSelected) {
      const projectId = localStorage.getItem("currentProjectId");
      const generationType = document.getElementById("button1").value;
      const startTime = this.state.startTime;

      let url = "/api/schedule-reports-generation?projectId=" +
        projectId +
        "&reportType=" +
        selectedReportTypeValue +
        "&startTime=" +
        startTime +
        "&generationType=" +
        generationType;

      if (parentDomainIdList.length > 0) {
        url += "&parentDomainIdList=" + parentDomainIdList.join(",");
      }

      // window.location.href = url;

      const link = document.createElement("a");
      link.href = url;
      link.setAttribute("download", "");
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
    } else {
      this.notifyDomainNotSelected();
    }
  };

  reportsGeneration = () => {
    const reportsGenerationController = this;
    const reportTypeElements = document.getElementsByName("reportType");
    let selectedReportTypeValue = null;
    const data = {};
    let domainSelected = true;

    for (let i = 0; i < reportTypeElements.length; i++) {
      if (reportTypeElements[i].checked) {
        selectedReportTypeValue = reportTypeElements[i].value;
        if (selectedReportTypeValue === "DOMAIN_WISE_REPORT") {
          if (reportsGenerationController.state.selectedDomainId != null) {
            data.parentDomainIdList = [reportsGenerationController.state.selectedDomainId];
          } else {
            domainSelected = false;
          }
        }
        if (selectedReportTypeValue === "DAILY_SUMMARY") {
          if (reportsGenerationController.state.selectedDailyReportDomains.length > 0) {
            data.parentDomainIdList = reportsGenerationController.state.selectedDailyReportDomains.map(domain => domain.value);
          } else {
            domainSelected = false;
          }
        }
        break;
      }
    }

    if (domainSelected) {
      data.projectId = localStorage.getItem("currentProjectId");
      data.reportType = selectedReportTypeValue;
      data.generationType = document.getElementById("button").value;
      data.startTime = reportsGenerationController.state.startTime;

      $.ajax({
        url: "/api/schedule-reports-generation",
        async: false,
        method: "GET",
        data: data,
        headers: {
          Authorization: "Bearer " + localStorage.getItem("access_token"),
        },
        success: function (res) {
          if (res.success === true) {
            reportsGenerationController.notifyAdd();
          } else {
            reportsGenerationController.notifyFailToLoad(res.result || "Failed to generate report.");
          }
        },
        error: function () {
          reportsGenerationController.notifyFailToLoad("An error occurred while generating the report.");
        }
      });
    } else {
      reportsGenerationController.notifyDomainNotSelected();
    }
  };

  timeIntervalreportsGeneration = () => {
    let reportTypeElements = document.getElementsByName("intervalReportType");
    let selectedReportTypeValue = null;
    let parentDomainIdList = [];

    for (let i = 0; i < reportTypeElements.length; i++) {
      if (reportTypeElements[i].checked) {
        selectedReportTypeValue = reportTypeElements[i].value;
        if (selectedReportTypeValue === "DOMAIN_WISE_REPORT") {
          parentDomainIdList = [this.state.selectedDomainId];
        }
        break;
      }
    }

    if (selectedReportTypeValue == "LEAD") {
      this.timeIntervalreportsGenerationForLead();
    } else {
      let projectId = localStorage.getItem("currentProjectId");
      let generationType = document.getElementById(
        "timeIntButtonDownload"
      ).value;
      let startTime = this.state.intervalStartTime;
      let endTime = this.state.intervalEndTime;

      if (startTime == endTime) {
        this.notifyRangeNotSelected();
      } else {
        let url =
          "/api/schedule-reports-generation/interval?projectId=" +
          projectId +
          "&reportType=" +
          selectedReportTypeValue +
          "&startTime=" +
          startTime +
          "&endTime=" +
          endTime +
          "&generationType=" +
          generationType;

        if (parentDomainIdList && parentDomainIdList.length > 0) {
          url += "&parentDomainIdList=" + parentDomainIdList.join(",");
        }
        // window.location.href = url;

        const link = document.createElement("a");
        link.href = url;
        link.setAttribute("download", "");
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
      }
    }
  };

  timeIntervalreportsGenerationForLead = () => {
    var projectId = localStorage.getItem("currentProjectId");
    var reportType = "LEAD";
    var generationType = document.getElementById("timeIntButtonDownload").value;
    var startTime = this.state.intervalStartTime;
    var endTime = this.state.intervalEndTime;

    if (startTime == endTime) {
      this.notifyRangeNotSelected();
    } else {
      var url =
        "/api/schedule-reports-generation/interval/lead?projectId=" +
        projectId +
        "&reportType=" +
        reportType +
        "&startTime=" +
        startTime +
        "&endTime=" +
        endTime +
        "&generationType=" +
        generationType;
      window.location.href = url;
    }
  };

  timeIntervalreportsGenerationEmail = () => {
    let reportsGenerationController = this;
    let reportTypeElements = document.getElementsByName("intervalReportType");
    let selectedReportTypeValue = null;
    let data = {};

    for (let i = 0; i < reportTypeElements.length; i++) {
      if (reportTypeElements[i].checked) {
        selectedReportTypeValue = reportTypeElements[i].value;
        if (selectedReportTypeValue === "DOMAIN_WISE_REPORT") {
          data.parentDomainIdList = [
            reportsGenerationController.state.selectedDomainId,
          ];
        }
        break;
      }
    }

    if (selectedReportTypeValue == "LEAD") {
      reportsGenerationController.timeIntervalreportsGenerationEmailForLead();
    } else {
      data.projectId = localStorage.getItem("currentProjectId");
      data.reportType = selectedReportTypeValue;
      data.generationType = document.getElementById("timeIntButtonEmail").value;
      data.startTime = reportsGenerationController.state.intervalStartTime;
      data.endTime = reportsGenerationController.state.intervalEndTime;

      $.ajax({
        url: "/api/schedule-reports-generation/interval",
        async: false,
        method: "GET",
        data: data,
        headers: {
          Authorization: "Bearer " + localStorage.getItem("access_token"),
        },
        success: function (res) {
          if (res.success === true) {
            reportsGenerationController.notifyAdd();
          } else {
            if (res.result == null) {
              reportsGenerationController.notifyFiled();
            } else {
              reportsGenerationController.notifyFailToLoad(res.result);
            }
          }
        },
      });
    }
  };

  timeIntervalreportsGenerationEmailForLead = () => {
    var reportsGenerationController = this;

    var data = {
      projectId: localStorage.getItem("currentProjectId"),
      reportType: "LEAD",
      generationType: document.getElementById("timeIntButtonEmail").value,
      startTime: reportsGenerationController.state.intervalStartTime,
      endTime: reportsGenerationController.state.intervalEndTime,
    };

    $.ajax({
      url: "/api/schedule-reports-generation/interval/lead",
      async: false,
      method: "GET",
      data: data,
      headers: {
        Authorization: "Bearer " + localStorage.getItem("access_token"),
      },
      success: function (res) {
        if (res.success === true) {
          reportsGenerationController.notifyAdd();
        } else {
          if (res.result == null) {
            reportsGenerationController.notifyFiled();
          } else {
            reportsGenerationController.notifyFailToLoad(res.result);
          }
        }
      },
    });
  };

  notifyAdd() {
    toast.dismiss();
    toast(
      <b>
        <img
          src="assets/images/done.svg"
          style={{ paddingRight: "0px" }}
          content=""
        />
        &nbsp;&nbsp;Report Generated Successfully
      </b>,
      {
        position: "top-center",
      }
    );
  }

  notifyRangeNotSelected() {
    toast.dismiss();
    toast(
      <b>
        <img
          src="assets/images/warn.svg"
          style={{ paddingRight: "0px", height: "20px", width: "20px" }}
          content=""
        />
        &nbsp;&nbsp;Oops! you have not selected date range
      </b>,
      {
        position: "top-center",
      }
    );
  }

  notifyDomainNotSelected() {
    toast.dismiss();
    toast(
      <b>
        <img
          src="assets/images/warn.svg"
          style={{ paddingRight: "0px", height: "20px", width: "20px" }}
          content=""
        />
        &nbsp;&nbsp;You have not selected any domain
      </b>,
      {
        position: "top-center",
      }
    );
  }

  notifyFailToLoad(response) {
    toast.dismiss();
    toast(<b>{response}</b>, {
      position: "top-center",
      color: "red",
    });
  }
  notifyFiled() {
    toast.dismiss();
    toast(<b style={{ color: "red" }}>oops!Failed to generate Report</b>, {
      position: "top-center",
      color: "red",
    });
  }

  reset = () => {
    this.onChange(new Date());
    this.resetValues();
    this.setState({ selectedReportType: "LEAD" });
    document.getElementById("leadReport").checked = true;
  };

  resetTimeInt = () => {
    this.onChange(new Date());
    this.setState({ intervalReportType: "LEAD" });
    document.getElementById("leadReportTimeInt").checked = true;
  };

  render() {
    const selectedDomainOption = this.state.selectedDomainName;
    return (
      <div>
        {/* Font Awesome Icons */}
        <link
          rel="stylesheet"
          href="plugins/font-awesome/css/font-awesome.min.css"
        />
        {/* Select2 */}
        <link rel="stylesheet" href="plugins/select2/select2.min.css" />
        {/* Theme style */}
        <link rel="stylesheet" href="assets/css/adminlte.css" />
        <link rel="stylesheet" href="assets/css/styles.css" />
        <link rel="stylesheet" href="assets/css/custom-style.css" />
        <div className="content-header"></div>
        {/* Main content */}
        <div className="content">
          <div className="container-fluid">
            <div className="row">
              <div className="col-12">
                {/* Custom Tabs */}
                <div className="row" style={{ marginLeft: "12px" }}>
                  <div className="col-6">
                    <label className="nav-link active show">
                      Daily Report Generation
                    </label>
                  </div>
                  <div className="col-6" Align="right">
                    <button
                      className="btn action-button"
                      title="reset"
                      onClick={this.reset}
                    >
                      {/* <img className="img-responsive" src="./assets/images/replay.svg" */}
                      Reset{" "}
                    </button>
                  </div>
                </div>
                <ToastContainer className="Toast-at-center" />
                {/* /.card-header */}
                <div
                  className="card-body p-0 mb-25"
                  style={{ marginLeft: "15px" }}
                >
                  <div className="tab-content col-12 p-0">
                    <div className="tab-pane active show" id="tab_1">
                      <div className="card card-primary mt-3">
                        <form role="form" className="raiseTicketLable">
                          <div className="card-body raise-form">
                            <div className="row"></div>
                            <div className="row">
                              <div className="col-sm-6">
                                <label className="col-12  ">Report Type:</label>
                              </div>
                              <div className="col-sm-6" Align="right"></div>
                            </div>

                            <div
                              className="row"
                              style={{ marginBottom: "5px", marginLeft: "10%" }}
                            >
                              <div className="col-sm-6">
                                <label>
                                  <input
                                    type="radio"
                                    id="leadReport"
                                    name="reportType"
                                    value="LEAD"
                                    defaultChecked
                                    onChange={(e) =>
                                      this.setState({
                                        selectedReportType: "LEAD",
                                      })
                                    }
                                  />
                                  &nbsp; Lead Report
                                </label>
                                <br />
                                <label>
                                  <input
                                    type="radio"
                                    id="categoryReport"
                                    name="reportType"
                                    value="CATEGORY"
                                    onChange={(e) =>
                                      this.setState({
                                        selectedReportType: "CATEGORY",
                                      })
                                    }
                                  />
                                  &nbsp; Category Report
                                </label>
                                <br />
                                <label>
                                  <input
                                    type="radio"
                                    id="deviceDemoReport"
                                    name="reportType"
                                    value="DEVICE_DEMOGRAPHY"
                                    onChange={(e) =>
                                      this.setState({
                                        selectedReportType: "DEVICE_DEMOGRAPHY",
                                      })
                                    }
                                  />
                                  &nbsp; Device Demography Report
                                </label>

                                <br />
                                <label>
                                  <input
                                    type="radio"
                                    id="locationReport"
                                    name="reportType"
                                    value="LOCATION"
                                    onChange={(e) =>
                                      this.setState({
                                        selectedReportType: "LOCATION",
                                      })
                                    }
                                  />
                                  &nbsp; Location Report
                                </label>
                                <br />
                                <label>
                                  <input
                                    type="radio"
                                    id="supportUserAuditReport"
                                    name="reportType"
                                    value="SUPPORT_USER_AUDIT_REPORT"
                                    onChange={(e) =>
                                      this.setState({
                                        selectedReportType: "SUPPORT_USER_AUDIT_REPORT",
                                      })
                                    }
                                  />
                                  &nbsp; Support User Audit Report
                                </label>
                                <br />
                                <label>
                                  <input
                                    type="radio"
                                    id="dailyPerformanceReport"
                                    name="reportType"
                                    value="DAILY_SUMMARY"
                                    onChange={(e) =>
                                      this.setState({
                                        selectedReportType: "DAILY_SUMMARY",
                                      })
                                    }
                                  />
                                  &nbsp; Daily Performance Report
                                </label>
                                <div
                                  style={{
                                    width: "100%",
                                    padding: "10px",
                                    borderRadius: "6px",
                                    display:
                                      this.state.selectedReportType ===
                                        "DAILY_SUMMARY"
                                        ? "block"
                                        : "none",
                                  }}
                                >
                                  <Multiselect
                                    options={this.domains}
                                    displayValue="label"
                                    closeIcon="cancel"
                                    placeholder="Select Domains"
                                    selectedValues={
                                      this.state.selectedDailyReportDomains
                                    }
                                    // preSelectedValues={this.state.selectedIntegerFields}
                                    className="multiSelectContainer"
                                    onSelect={
                                      this.handleDailyReportDomainChange
                                    }
                                    onRemove={
                                      this.handleRemoveDailyReportDomain
                                    }
                                    // onSearch={(e) => this.checkTreatmentName(e)}
                                    ref={this.multiselectRef}
                                  />
                                </div>
                              </div>
                              <div className="col-sm-6">
                                <label>
                                  <input
                                    type="radio"
                                    id="utteranceReport"
                                    name="reportType"
                                    value="UTTERANCE"
                                    onChange={(e) =>
                                      this.setState({
                                        selectedReportType: "UTTERANCE",
                                      })
                                    }
                                  />
                                  &nbsp; Utterance Report
                                </label>
                                <br />
                                <label>
                                  <input
                                    type="radio"
                                    id="missedQueryReport"
                                    name="reportType"
                                    value="MISSED_QUERY"
                                    onChange={(e) =>
                                      this.setState({
                                        selectedReportType: "MISSED_QUERY",
                                      })
                                    }
                                  />
                                  &nbsp; Missed Query Report
                                </label>
                                <br />
                                <label>
                                  <input
                                    type="radio"
                                    id="missedQueryReportAttended"
                                    name="reportType"
                                    value="MISSED_QUERY_ATTENDED"
                                    onChange={(e) =>
                                      this.setState({
                                        selectedReportType:
                                          "MISSED_QUERY_ATTENDED",
                                      })
                                    }
                                  />
                                  &nbsp; Missed Query Report - Attended
                                </label>
                                <br />
                                <label>
                                  <input
                                    type="radio"
                                    id="missedQueryReportUnattended"
                                    name="reportType"
                                    value="MISSED_QUERY_UNATTENDED"
                                    onChange={(e) =>
                                      this.setState({
                                        selectedReportType:
                                          "MISSED_QUERY_UNATTENDED",
                                      })
                                    }
                                  />
                                  &nbsp; Missed Query Report - Unattended
                                </label>
                                <br />
                                <label>
                                  <input
                                    type="radio"
                                    id="customerSatisfactionReport"
                                    name="reportType"
                                    value="C_SAT"
                                    onChange={(e) =>
                                      this.setState({
                                        selectedReportType: "C_SAT",
                                      })
                                    }
                                  />
                                  &nbsp; Customer Satisfaction Report
                                </label>
                                <br />
                                <label>
                                  <input
                                    type="radio"
                                    id="uniqueUsersReport"
                                    name="reportType"
                                    value="UNIQUE_USERS_REPORT"
                                    onChange={(e) =>
                                      this.setState({
                                        selectedReportType:
                                          "UNIQUE_USERS_REPORT",
                                      })
                                    }
                                  />
                                  &nbsp; Unique Users Report
                                </label>
                                <div
                                  style={{
                                    display: "flex",
                                    alignItems: "baseline",
                                    gap: "2rem",
                                  }}
                                >
                                  <label style={{ flex: "none" }}>
                                    <input
                                      type="radio"
                                      id="domainWiseReport"
                                      name="reportType"
                                      value="DOMAIN_WISE_REPORT"
                                      onChange={(e) =>
                                        this.setState({
                                          selectedReportType:
                                            "DOMAIN_WISE_REPORT",
                                        })
                                      }
                                    />
                                    &nbsp; Domain Wise Report
                                  </label>
                                  <Select
                                    styles={{
                                      control: (baseStyles) => ({
                                        ...baseStyles,
                                        visibility:
                                          this.state.selectedReportType ===
                                            "DOMAIN_WISE_REPORT"
                                            ? "visible"
                                            : "hidden",
                                      }),
                                    }}
                                    value={this.domains.filter(
                                      (option) =>
                                        option.label === selectedDomainOption
                                    )}
                                    onChange={this.handleDomainChange}
                                    options={this.domains}
                                  />
                                </div>
                              </div>
                            </div>
                            <div className="row">
                              <div className="col-sm-6">
                                <label className="col-12  ">Select Date:</label>
                              </div>
                            </div>
                            <div style={{ marginLeft: "8.5%" }}>
                              <Calendar
                                onChange={this.onChange}
                                value={this.state.date}
                                maxDate={new Date()}
                              />
                            </div>

                            <div className="form-group col-6" Align="center">
                              <label className="col-12 pull-left" />
                              <button
                                type="button"
                                className="btn navyblue-btn"
                                title="Send Email"
                                style={{ width: "23%", height: "45px" }}
                                id="button"
                                value="EMAIL"
                                onClick={this.reportsGeneration}
                              >
                                Send Email
                              </button>
                              <button
                                type="button"
                                className="btn navyblue-btn"
                                title="Download"
                                style={{ width: "23%", height: "45px" }}
                                id="button1"
                                value="DOWNLOAD"
                                onClick={this.downloadReport}
                              >
                                Download
                              </button>
                            </div>
                          </div>
                        </form>
                        <div className="row">
                          <div className="col-6">
                            <label className="nav-link active show">
                              Time Interval Report Generation
                            </label>
                          </div>
                          <div className="col-6" Align="right">
                            <button
                              className="btn action-button"
                              title="reset"
                              onClick={this.resetTimeInt}
                            >
                              Reset{" "}
                            </button>
                          </div>
                        </div>

                        <form role="form" className="raiseTicketLable">
                          <div className="card-body raise-form">
                            <div className="row"></div>
                            <div className="row">
                              <div className="col-sm-6">
                                <label className="col-12  ">Report Type:</label>
                              </div>
                            </div>
                            <div
                              className="row"
                              style={{ marginBottom: "5px", marginLeft: "10%" }}
                            >
                              <div className="col-sm-6">
                                <label>
                                  <input
                                    type="radio"
                                    id="leadReportTimeInt"
                                    name="intervalReportType"
                                    value="LEAD"
                                    defaultChecked
                                    onChange={(e) =>
                                      this.setState({
                                        intervalReportType: "LEAD",
                                      })
                                    }
                                  />
                                  &nbsp; Lead Report
                                </label>
                                <br />
                                <label>
                                  <input
                                    type="radio"
                                    id="categoryReportTimeInt"
                                    name="intervalReportType"
                                    value="CATEGORY"
                                  />
                                  &nbsp; Category Report
                                </label>
                                <br />
                                <label>
                                  <input
                                    type="radio"
                                    id="deviceDemoReportTimeInt"
                                    name="intervalReportType"
                                    value="DEVICE_DEMOGRAPHY"
                                    onChange={(e) =>
                                      this.setState({
                                        intervalReportType: "DEVICE_DEMOGRAPHY",
                                      })
                                    }
                                  />
                                  &nbsp; Device Demography Report
                                </label>
                                <br />
                                <label>
                                  <input
                                    type="radio"
                                    id="locationReportTimeInt"
                                    name="intervalReportType"
                                    value="LOCATION"
                                    onChange={(e) =>
                                      this.setState({
                                        intervalReportType: "LOCATION",
                                      })
                                    }
                                  />
                                  &nbsp; Location Report
                                </label>
                                <br />
                                <label>
                                  <input
                                    type="radio"
                                    id="uniqueUsersReportTimeInt"
                                    name="intervalReportType"
                                    value="UNIQUE_USERS_REPORT"
                                    onChange={(e) =>
                                      this.setState({
                                        intervalReportType:
                                          "UNIQUE_USERS_REPORT",
                                      })
                                    }
                                  />
                                  &nbsp; Unique Users Report
                                </label>
                                <br />
                                <label>
                                  <input
                                    type="radio"
                                    id="supportUserAuditReportTimeInt"
                                    name="intervalReportType"
                                    value="SUPPORT_USER_AUDIT_REPORT"
                                    onChange={(e) =>
                                      this.setState({
                                        intervalReportType:
                                          "SUPPORT_USER_AUDIT_REPORT",
                                      })
                                    }
                                  />
                                  &nbsp; Support User Audit Report
                                </label>
                              </div>
                              <div className="col-sm-6">
                                <label>
                                  <input
                                    type="radio"
                                    id="utteranceReportTimeInt"
                                    name="intervalReportType"
                                    value="UTTERANCE"
                                    onChange={(e) =>
                                      this.setState({
                                        intervalReportType: "UTTERANCE",
                                      })
                                    }
                                  />
                                  &nbsp; Utterance Report
                                </label>
                                <br />
                                <label>
                                  <input
                                    type="radio"
                                    id="missedQueryReportTimeInt"
                                    name="intervalReportType"
                                    value="MISSED_QUERY"
                                    onChange={(e) =>
                                      this.setState({
                                        intervalReportType: "MISSED_QUERY",
                                      })
                                    }
                                  />
                                  &nbsp; Missed Query Report
                                </label>
                                <br />
                                <label>
                                  <input
                                    type="radio"
                                    id="missedQueryReportAttendedTimeInt"
                                    name="intervalReportType"
                                    value="MISSED_QUERY_ATTENDED"
                                    onChange={(e) =>
                                      this.setState({
                                        intervalReportType:
                                          "MISSED_QUERY_ATTENDED",
                                      })
                                    }
                                  />
                                  &nbsp; Missed Query Report - Attended
                                </label>
                                <br />
                                <label>
                                  <input
                                    type="radio"
                                    id="missedQueryReportUnattendedTimeInt"
                                    name="intervalReportType"
                                    value="MISSED_QUERY_UNATTENDED"
                                    onChange={(e) =>
                                      this.setState({
                                        intervalReportType:
                                          "MISSED_QUERY_UNATTENDED",
                                      })
                                    }
                                  />
                                  &nbsp; Missed Query Report - Unattended
                                </label>
                                <br />
                                <label>
                                  <input
                                    type="radio"
                                    id="customerSatisfactionReport"
                                    name="intervalReportType"
                                    value="C_SAT"
                                    onChange={(e) =>
                                      this.setState({
                                        intervalReportType: "C_SAT",
                                      })
                                    }
                                  />
                                  &nbsp; Customer Satisfaction Report
                                </label>

                                <br />
                                <div
                                  style={{
                                    display: "flex",
                                    alignItems: "baseline",
                                    gap: "2rem",
                                  }}
                                >
                                  <label style={{ flex: "none" }}>
                                    <input
                                      type="radio"
                                      id="domainWiseReportTimeInt"
                                      name="intervalReportType"
                                      value="DOMAIN_WISE_REPORT"
                                      onChange={(e) =>
                                        this.setState({
                                          intervalReportType:
                                            "DOMAIN_WISE_REPORT",
                                        })
                                      }
                                    />
                                    &nbsp; Domain Wise Report
                                  </label>
                                  <Select
                                    styles={{
                                      control: (baseStyles) => ({
                                        ...baseStyles,
                                        visibility:
                                          this.state.intervalReportType ===
                                            "DOMAIN_WISE_REPORT"
                                            ? "visible"
                                            : "hidden",
                                      }),
                                    }}
                                    value={this.domains.filter(
                                      (option) =>
                                        option.label === selectedDomainOption
                                    )}
                                    onChange={this.handleDomainChange}
                                    options={this.domains}
                                  />
                                </div>
                              </div>
                            </div>
                            <div className="row">
                              <div className="col-sm-6">
                                <label className="col-12">
                                  Select Date Range:
                                </label>
                              </div>
                            </div>
                            <div style={{ marginLeft: "8.5%" }}>
                              <Calendar
                                selectRange
                                onChange={this.onDateChange}
                                maxDate={maxDate}
                              />
                            </div>
                            <div className="form-group col-6" Align="center">
                              <label className="col-12 pull-left" />
                              <button
                                type="button"
                                className="btn navyblue-btn"
                                title="Send Email"
                                id="timeIntButtonEmail"
                                value="EMAIL"
                                style={{ width: "23%", height: "45px" }}
                                onClick={
                                  this.timeIntervalreportsGenerationEmail
                                }
                              >
                                Send Email
                              </button>
                              <button
                                type="button"
                                className="btn navyblue-btn"
                                title="Download"
                                style={{ width: "23%", height: "45px" }}
                                value="DOWNLOAD"
                                id="timeIntButtonDownload"
                                onClick={this.timeIntervalreportsGeneration}
                              >
                                Download
                              </button>
                            </div>
                          </div>
                        </form>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export default GenerateReport;



// WEBPACK FOOTER //
// ./src/projectmgmt/reports/GenerateReport.js